import { useEffect } from "react";
import './Support.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import { useNavigate, useLocation } from "react-router-dom";
 

const Support = ()=> {


    const navigate = useNavigate();
    const location = useLocation();

       // Function to handle navigation
       const handleNavigation = (section) => {
        if (location.pathname !== "/") {
            navigate("/", { state: { scrollTo: section } });
        } else {
            scrollToSection(section);
        }
    };

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);


    return (
        <>
            <AIheader/>

 

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Support</h1>
                                    <p>We’re here<br/> when you need us.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
 
            {/* START supportPageMain */}
             <section className='supportPageMain'>
                 <div className='container'> 
                     <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageLeft'>
                                <img className="img-fluid" src="/img/Support/user_question_sp.svg" alt="rent id"/>
                                <h3>FAQs</h3>
                                <p>Find answers to common questions <br/>about our platform, policies, & features.</p>
                                <a onClick={() => handleNavigation("support")} className="btn btnBlue">Explore</a>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageRight'>
                                <img className="img-fluid" src="/img/Support/ranking_sp.svg" alt="rent id"/>
                                <h3>Success Manager </h3>
                                <p>Personalized support to help you <br/>optimize & grow your rental business.</p>
                                <a href="/rentsuccess#businessEmpowerment_2" className="btn btnBlue">Explore</a>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageLeft'>
                                <img className="img-fluid" src="/img/Support/target_sp.svg" alt="rent id"/>
                                <h3>Marketing Team</h3>
                                <p>Strategies and resources to enhance <br/>visibility and attract more customers.</p>
                                <a href="/rentsuccess#businessEmpowerment_3" className="btn btnGrad_1">Coming Soon</a>
                             </div>
                         </div>
                         <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                             <div className='supportPageInner supportPageRight'>
                                <img className="img-fluid" src="/img/Support/mail_account_sp.svg" alt="rent id"/>
                                <h3>Contact Us</h3>
                                <p>Reach out for assistance—we’re here <br/>to support you every step of the way.</p>
                                <a href="/general-question" className="btn btnBlue">Explore</a>
                             </div>
                         </div>
                     </div>
                 </div>
             </section>
             {/* END generalConversationsMain */}
   
            <Footer/>
        </>
    )
}

export default Support;